"use client"

import sdk from "@farcaster/frame-sdk"
import { verifyNonce } from "@/api_routes/user"

import { verifyMessage } from "ethers/lib/utils"

function generateNonce(length: number = 8): string {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  let nonce = ""
  for (let i = 0; i < length; i++) {
    nonce += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return nonce
}

export async function loginFcUser() {
  // Check if user is logged into Paragraph. If so, don't relog them in.
  /*const loggedIn = await isUserLoggedIn()

  if (loggedIn) {
    console.warn("User already logged in; not relogging in")
    const user = await getUser()
    const context = await sdk.context
    const ok = context.s
    return {
      custodyAddress: sdk.context

    }
  }*/

  const nonce = generateNonce()

  console.log("SIGNING IN", nonce)

  const signedData = await sdk.actions.signIn({
    nonce,
  })

  console.log("Verifying nonce", signedData)

  const custodyAddress = verifyMessage(signedData.message, signedData.signature)

  console.log("CUSTODY ADDRESS", custodyAddress)

  // This actually stores the JWT token in the browser.
  const verified = await verifyNonce({
    wallet_address: custodyAddress,
    signature: signedData.signature,
    message: signedData.message,
  })

  if (verified) {
    console.log("VERIFIED")
  }

  return {
    user: verified,
    custodyAddress: custodyAddress,
  }
}
